import { CSSProperties, ReactNode } from "react";

// MUI
import { Stack, Typography } from "@mui/material";

// Components
import RoundedBox from "./RoundedBox.tsx";

type EmptyBodyProps = {
	bodyHeight?: string; //deprecated in the future, use bodyHeightClassName
	bodyHeightClassName?: string; //ONLY Tailwind CSS classes, use this instead of bodyHeight
	image?: string;
	imageStyles?: CSSProperties; //deprecated in the future
	title?: string | ReactNode;
	sx?: CSSProperties; //deprecated in the future, use className
	className?: string; //ONLY Tailwind CSS classes, use this instead of sx
	style?: CSSProperties; //This is ONLY for variable styles
};
export default function EmptyBody(props: Readonly<EmptyBodyProps>) {
	const { bodyHeight = "", image, imageStyles = {}, title = "", sx, className = "", bodyHeightClassName = "", style } = props;

	return (
		<RoundedBox className={className} sx={sx || { boxShadow: "none !important" }}>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={bodyHeightClassName}
				sx={{ height: bodyHeight }}
				style={style}
			>
				<img src={image} alt="empty" style={imageStyles} />
				<Typography variant="h6" component="div" className={"!font-montserrat !text-[16px] font-medium !text-default !mt-[30px]"}>
					{title}
				</Typography>
			</Stack>
		</RoundedBox>
	);
}
